export const styles = () => ({
    container: {
        padding: '1.5rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '1rem 0',
    },
});
